module.exports = __webpack_public_path__ + "images/343ddb3e35218660d3b481b777dbd6668.svg";